const THEMES = {
    default: {
        '--theme-primary':           '#4ECDC4',
        '--theme-secondary':         '#29958E',
        '--theme-text':              '#ffffff',
        '--theme-subtext':           'rgba(255,255,255,0.6)',
        '--theme-transparent':       'rgba(78,205,196,0.35)',
        '--theme-light-transparent': 'rgba(78,205,196,0.15)',
        '--theme-modal-overlay':     'rgba(78,205,196,0.9)',
        '--theme-drop-highlight':    '#7DDDD8',
        '--theme-bg-primary':        'hsla(176,56%,95%,1)',
        '--theme-bg-secondary':      'hsla(176,42%,95%,1)',
        '--theme-bg-tertiary':       'hsla(176,28%,90%,1)',
        '--theme-ring1':             '#E3FAFC',
        '--theme-ring2':             '#74C0FC',
        '--theme-ring3':             '#1098AD',
        '--theme-ring4':             '#0B7285'
    },
    dark: {
        '--theme-primary':           '#0B2E3C',
        '--theme-secondary':         '#1098AD',
        '--theme-text':              '#ffffff',
        '--theme-subtext':           '#74C0FC',
        '--theme-transparent':       'rgba(11,46,60,0.35)',
        '--theme-light-transparent': 'rgba(11,46,60,0.15)',
        '--theme-modal-overlay':     'rgba(11,46,60,0.9)',
        '--theme-drop-highlight':    '#1098AD',
        '--theme-bg-primary':        '#0d2233',
        '--theme-bg-secondary':      '#0e2536',
        '--theme-bg-tertiary':       '#0f2a3a',
        '--theme-ring1':             '#E3FAFC',
        '--theme-ring2':             '#74C0FC',
        '--theme-ring3':             '#1098AD',
        '--theme-ring4':             '#0B7285'
    },
    pink: {
        '--theme-primary':           '#FFB3BC',
        '--theme-secondary':         '#FF8896',
        '--theme-text':              '#5c2333',
        '--theme-subtext':           'rgba(92,35,51,0.6)',
        '--theme-transparent':       'rgba(255,179,188,0.35)',
        '--theme-light-transparent': 'rgba(255,179,188,0.15)',
        '--theme-modal-overlay':     'rgba(255,179,188,0.9)',
        '--theme-drop-highlight':    '#FFCDD2',
        '--theme-bg-primary':        '#fff0f2',
        '--theme-bg-secondary':      '#ffe4e8',
        '--theme-bg-tertiary':       '#ffd6db',
        '--theme-ring1':             '#ffffff',
        '--theme-ring2':             '#FFD6DB',
        '--theme-ring3':             '#FF8896',
        '--theme-ring4':             '#E05C6E'
    }
};

const STORAGE_KEY = 'picoblock-theme';

const applyTheme = name => {
    const theme = THEMES[name] || THEMES.default;
    const root = document.documentElement;
    Object.entries(theme).forEach(([prop, val]) => {
        root.style.setProperty(prop, val);
    });
    localStorage.setItem(STORAGE_KEY, name);
    document.documentElement.setAttribute('data-theme', name);
};

const getSavedTheme = () => localStorage.getItem(STORAGE_KEY) || 'default';

const initTheme = () => applyTheme(getSavedTheme());

export {THEMES, applyTheme, getSavedTheme, initTheme};
